import { commonViewTexts } from '../common';
import { deleteDialogCommonViewTexts } from './delete-dialog-common';

const targetName = commonViewTexts.project;

export const deleteProjectDialogViewTexts = {
  title: targetName,
  message: deleteDialogCommonViewTexts.messageGenerator1(targetName)
} as const;
